import { gql, useQuery } from '@apollo/client'
import { currentMarketIdVar } from 'graphql/reactive'

export const GET_PROFILE_REFERRAL_CODE = gql`
  query GetPublicProfileReferralCode($marketId: ID!, $code: ID!) {
    market(id: $marketId) {
      id
      profileReferralCode(code: $code) {
        id
        active
        code
        profile {
          slug
          name
        }
      }
    }
  }
`

export default function useProfileReferralCode({ code, skip }) {
  const marketId = currentMarketIdVar()

  const { loading, error, data } = useQuery(GET_PROFILE_REFERRAL_CODE, {
    variables: {
      code,
      marketId,
    },
    skip,
  })

  const profileReferralCode = data?.market?.profileReferralCode

  return { loading, error, profileReferralCode }
}
